module.exports = __webpack_public_path__ + "img/icon-social-media.c2a4f97b.png";